"use client";

import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname, withLocale } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";

export function CaseStudies() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).landing;

  return (
    <section id="use-cases" className="container mx-auto px-4 md:px-6 py-12">
      <SectionHeader 
        title={content.useCasesTitle} 
        description={content.useCasesDescription}
      />
      
      <div className="bg-positivus-dark rounded-[45px] py-12 overflow-x-auto">
        <div className="flex gap-8 px-8 min-w-max">
          {content.useCases.map((useCase, index) => (
            <div key={index} className="bg-[#292A32] p-10 rounded-[45px] w-[350px] md:w-[450px] flex-shrink-0">
               <div className="space-y-6">
                 <h3 className="text-2xl md:text-3xl text-positivus-green font-medium">
                   {useCase.title}
                 </h3>
                 <p className="text-white text-base md:text-lg">
                   {useCase.description}
                 </p>
                 <div className="pt-4">
                    <Link href={withLocale(locale, "/tools")} className="flex items-center gap-4 group cursor-pointer text-positivus-green">
                       <span className="text-xl">{content.useCasesCta}</span>
                       <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </Link>
                 </div>
               </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
